export default {
  "content": "<g clip-path=\"url(#clip0_9595_4953)\"><g clip-path=\"url(#clip1_9595_4953)\"><path d=\"M40.3 44H15.212c-1.352 0-2.65-.55-3.606-1.528l-2.61-2.67A3.52 3.52 0 018 37.341V5.739C8 4.78 8.761 4 9.7 4h25.5c.939 0 1.7.779 1.7 1.74v31.304c0 .96-.761 1.739-1.7 1.739H13.807a.425.425 0 00-.392.268.442.442 0 00.092.474l.476.487c.32.327.752.51 1.202.51h22.99a.43.43 0 00.425-.435V9.652c0-.24.19-.435.425-.435H40.3c.939 0 1.7.779 1.7 1.74V42.26c0 .96-.761 1.739-1.7 1.739z\" fill=\"#3F4450\"/></g></g><defs><clipPath id=\"clip0_9595_4953\"><path fill=\"#fff\" d=\"M0 0h48v48H0z\"/></clipPath><clipPath id=\"clip1_9595_4953\"><path fill=\"#fff\" d=\"M0 0h48v48H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "48",
    "height": "48",
    "viewBox": "0 0 48 48",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};